import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VerificationCodeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const Code = localStorage.getItem('Code');
    const listPermissions = localStorage.getItem('Permissions');
    const JWT = localStorage.getItem('JWT');
    
    if(Code === null && listPermissions !== null && JWT !== null){
      return true;
    }
    else{
      this.router.navigate(['/home']);
      return false;
    }
  }
};
